import React from 'react';

interface NavigationLinkProps {
	href: string;
	children: React.ReactNode;
	className?: string;
	isMobile?: boolean;
	onMouseEnter?: () => void;
}

const NavigationLink: React.FC<NavigationLinkProps> = ({ 
	href, 
	children, 
	className = '', 
	isMobile = false,
	onMouseEnter
}) => {
	const baseClass = isMobile 
		? 'c-mobile-navigation__menu-link u-bold-04'
		: 'c-navigation__menu-link u-bold-10';
	
	const containerClass = isMobile 
		? 'c-mobile-navigation__menu-item'
		: 'c-navigation__menu-item';

	return (
		<li className={containerClass}>
			<a
				href={href}
				className={`${baseClass} ${className}`.trim()}
				onMouseEnter={onMouseEnter}
			>
				{isMobile ? (
					children
				) : (
					<span className="c-navigation__menu-link-label">
						{children}
					</span>
				)}
			</a>
		</li>
	);
};

export default NavigationLink; 